import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { put } from 'utils/http'

// Maps the UI quota row to the Reveal PUT field; the proxy does the read-modify-write (Reveal replaces all dimensions), so the client sends only the changed dimension.
const DIMENSION_FIELD = {
  requests: 'requestQuota',
  identified: 'identifiedQuota',
  uniqueIdentifiedIps: 'uniqueIdentifiedQuota',
}

export const useCustomerRevealApiExtraQuotaSet = () => {
  const customerId = useCustomerId()
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  const setExtraQuota = ({ type, value }: any) =>
    put(`/management/customers/${customerId}/reveal_api/extra-quotas`, {
      dimension: DIMENSION_FIELD[type],
      value: Number(value),
    })

  return useMutation({
    mutationFn: setExtraQuota,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'reveal_api_quota'] })
      addNotification('Temporary credits set')
    },
    onError: () => addNotification('Failed to set temporary credits', 'error'),
  })
}
